
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.3824 17.1666H6.19909H6.18742C5.23742 17.1666 4.39325 16.8266 3.74659 16.1808C2.99659 15.4333 2.58325 14.3591 2.58325 13.1566V7.43329C2.58325 5.10579 4.10492 3.41663 6.20075 3.41663H14.3824C16.4783 3.41663 17.9999 5.10579 17.9999 7.43329V13.1566C17.9999 14.3591 17.5874 15.4333 16.8366 16.1808C16.1899 16.8266 15.3466 17.1666 14.3958 17.1666C14.3908 17.1666 14.3841 17.165 14.3824 17.1666ZM2.86409 17.0666C3.75075 17.95 4.89909 18.4166 6.18492 18.4166H6.20075H14.3824H14.3958C15.6841 18.4166 16.8333 17.9491 17.7191 17.0666C18.7066 16.0816 19.2499 14.6933 19.2499 13.1566V7.43329C19.2499 4.43079 17.1574 2.16663 14.3824 2.16663H6.20075C3.42575 2.16663 1.33325 4.43079 1.33325 7.43329V13.1566C1.33325 14.6933 1.87659 16.0816 2.86409 17.0666ZM8.73573 11.1681C9.20073 11.5365 9.75657 11.7206 10.3141 11.7206C10.8732 11.7206 11.4332 11.5348 11.9016 11.1631L15.6049 8.15313C15.8724 7.9348 15.9132 7.54146 15.6957 7.27396C15.4774 7.00563 15.0841 6.96396 14.8157 7.18313L11.1191 10.1881C10.6466 10.5631 9.98573 10.5631 9.51657 10.1915L5.7824 7.18146C5.51407 6.96563 5.12073 7.00813 4.90323 7.27563C4.6874 7.54396 4.72907 7.93813 4.99823 8.1548L8.73573 11.1681Z","fill":"#141B22"}})])
          )
        }
      }
    